import { cn } from '@/utils'

import { TIPTAP_CLASSES } from './tiptap/tiptap-config'
import {
  createJSONContentFromHTMLContent,
  renderJSONContentAsReactNode,
} from './tiptap/tiptap-helpers'

/**
 * Component that renders a cell's content as a preview.
 * Does not depend on context.
 *
 * @note Not completely static, some extensions have interactions.
 */
export function ContentPreviewRenderer({
  contentAsHTML,
  className,
}: {
  contentAsHTML: string | object
} & React.ComponentProps<'div'>) {
  if (!contentAsHTML || typeof contentAsHTML !== 'string') return null

  const jsonContent = createJSONContentFromHTMLContent(contentAsHTML)

  const reactElement = renderJSONContentAsReactNode(jsonContent)

  return (
    <div
      role="none" // a11y purely structural
      className={cn(TIPTAP_CLASSES.BASE, TIPTAP_CLASSES.STATIC, className)}
    >
      {reactElement}
    </div>
  )
}
